import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Layer, Text, Box, TextInput, Anchor, Button } from 'grommet';
import { Attachment, FormClose, Close } from 'grommet-icons';

import { Placeholder } from '../../../../components';
import { TitleDetail, SimpleDetail, Hr } from '../../../../components/detail';

import visibleWidth from '../../../../constants/layer-width';

import { formattedNumber } from '../../../../utils';

import { uploadFile, deleteFile, toggleFormCreateArchiveLayer } from '../../actions/form-archive';
import { changeValues } from '../../../../actions/form';

class FormCreateArchive extends Component {
  handlePost = formParams => {
    const {
      uploadFile
    } = this.props;

    uploadFile({ formParams });
  };

  handleDelete = formParams => {
    const {
      deleteFile,
      changeValues,
    } = this.props;

    const { file, treatmentId } = formParams;

    changeValues(
      { fieldName: 'files', value: file },
      'formRemoveValues'
    );

    deleteFile({
      formParams: { treatmentId, id: file.id, key: file.key }
    });
  }

  handlerChooseFile = formParams => {
    const {
      uploadedFile
    } = formParams;


    if(uploadedFile.size > 1024 * 1024)
      return;

    const { changeValues } = this.props;

    changeValues(
      { fieldName: 'fileStream', value: uploadedFile },
      'formChangeValues'
    );
  }

  render() {
    const {
      id,
      reference,
      fileStream,
      files,

      getServerPresponseError,
      watingServerResponse,

      toggleLayer,
      loadingPostForm,
      toggleFormCreateArchiveLayer,
    } = this.props;


    if(!toggleLayer || toggleLayer !== 'createArchive')
      return null

    return (
      <ResponsiveContext.Consumer>
        {size => (
          <Layer
            responsive={false}
            full='vertical'
            position='left'
            onClickOutside={toggleFormCreateArchiveLayer}
            onEsc={toggleFormCreateArchiveLayer}
          >
            <Box
              fill='vertical'
              width={visibleWidth[size]}
              pad={{ top: 'large', bottom: 'xsmall' }}
              overflow='auto'
              flex
            >
              {watingServerResponse && !id && !getServerPresponseError ? (
                <Placeholder
                  title='Carregando...'
                  message='Aguarde que estamos preparando as coisas :)'
                />
              ) : null}

              {getServerPresponseError ? (
                <Placeholder
                  title='Ops! Algo deu errado :('
                  message='Estamos constrangidos por isso.'
                  button={{
                    label: 'Fechar',
                    action: toggleFormCreateArchiveLayer,
                  }}
                />
              ) : null}

              {!getServerPresponseError && (id || !watingServerResponse) ? (
                <>
                  <Box
                    direction='row'
                    justify='between'
                    align='baseline'
                    margin={{ horizontal: 'large' }}
                  >
                    <TitleDetail value='Gerenciar arquivos' />

                    <Button
                      plain
                      title='Fechar'
                      icon={<FormClose />}
                      onClick={toggleFormCreateArchiveLayer}
                    />
                  </Box>


                  <Box
                    flex
                    overflow='auto'
                  >
                    <SimpleDetail
                      title='Referência'
                      value={reference}
                      description='Código do atendimento que esta publicando ou excluindo arquivos.'
                      width={{
                        title: '50vw',  value: '50vw'
                      }}
                    />

                    <Hr />


                    <Box
                      justify='center'
                      overflow='auto'
                      flex
                    >
                      {!fileStream && files.length > 0 && (
                        <Box
                          margin={{
                            vertical: 'small',
                            horizontal: 'large'
                          }}
                          flex={{ shrink: 0 }}
                        >
                          <Box
                            round='small'
                            border={{ color: 'light-4' }}
                          >
                            {files.map(file => (
                              <Box
                                key={file.id}
                                align='center'
                                direction='row'
                                pad={{
                                  vertical: size === 'small' ? 'large' : 'small',
                                  horizontal: size === 'small' ? 'large' : 'small',
                                }}
                                justify='between'
                              >
                                <Text size='small'>{file.name}</Text>

                                <Anchor
                                  icon={<Close size='small' />}
                                  color='status-critical'
                                  title='Remover arquivo. Essa ação não pode ser desfeita.'
                                  onClick={() =>
                                    this.handleDelete({ treatmentId: id, file })
                                  }
                                />
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      )}


                      {/* Upload file */}
                      <Box
                        margin={{
                          vertical: 'small',
                          horizontal: 'large'
                        }}
                        flex={{ shrink: 0 }}
                      >
                        {!fileStream && (
                          <Box
                            pad={{
                              vertical: size === 'small' ? 'large' : 'small'
                            }}
                            align='center'
                            flex={{ shrink: 0 }}
                            gap={'xsmall'}
                          >
                            <TextInput
                              style={{
                                opacity: 0,
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                cursor: 'pointer',
                                height: '100%',
                                width: '100%'
                              }}
                              type='file'
                              accept='image/*,application/pdf'
                              onChange={event =>
                                this.handlerChooseFile({ uploadedFile: event.target.files[0] })
                              }
                            />

                            <Box
                              direction='row'
                              align='center'
                              gap='small'
                            >
                              <Attachment color='brand' />

                              <Text color='brand' size='small'>
                                Novo arquivo, clique para selecionar.
                              </Text>
                            </Box>

                            <Box>
                              <Text color='dark-3' size='small'>
                                O arquivo deve ter até 2MB e deve ter uma das extensões: .jpg, .png, .pdf.
                              </Text>
                            </Box>
                          </Box>
                        )}
                      </Box>


                      {fileStream && (
                        <Box
                          margin={{
                            vertical: 'small',
                            horizontal: 'large'
                          }}
                          flex={{ shrink: 0 }}
                          gap={'small'}
                        >
                          <Box
                            pad={{
                              vertical: size === 'small' ? 'large' : 'medium',
                              horizontal: size === 'small' ? 'large' : 'small',
                            }}
                            round='small'
                            border={{ color: 'light-4' }}
                            gap={'small'}
                          >
                            <Box direction='row' justify='between'>
                              <Text size='small' color='dark-2'>
                                Arquivo selecionado
                              </Text>

                              <Text size='small' color='dark-3'>
                                {fileStream.name}
                              </Text>
                            </Box>

                            <Box direction='row' justify='between'>
                              <Text size='small' color='dark-2'>
                                Tamanho
                              </Text>

                              <Text size='small' color='dark-3'>
                                {formattedNumber(fileStream.size)} bytes
                              </Text>
                            </Box>

                            <Box direction='row' justify='between'>
                              <Text size='small' color='dark-2'>
                                Tipo
                              </Text>

                              <Text size='small' color='dark-3'>
                                {fileStream.type}
                              </Text>
                            </Box>
                          </Box>
                        </Box>
                      )}
                    </Box>



                    {fileStream && (
                      <Box
                        direction='row'
                        pad={{ vertical: 'medium' }}
                        justify='center'
                        align='center'
                        gap='small'
                      >
                        <Box width='xsmall'>
                          <Anchor
                            color='dark-3'
                            label='Cancelar'
                            disabled={ loadingPostForm }
                            onClick={toggleFormCreateArchiveLayer}
                          />
                        </Box>

                        <Box width='small'>
                          <Button
                            color='brand'
                            primary
                            label={ !loadingPostForm ? 'Salvar' : 'Salvando...' }
                            disabled={ loadingPostForm }
                            onClick={() =>
                              this.handlePost({
                                id,
                                fileStream,
                              })
                            }
                          />
                        </Box>
                      </Box>
                    )}
                  </Box>
                </>
              ) : null}
            </Box>
          </Layer>
        )}
      </ResponsiveContext.Consumer>
    )
  }
}

const mapStateToProps = ({ layerReducer, formCreateUpdateCopyGeneric }) => ({
  id: formCreateUpdateCopyGeneric.id,
  reference: formCreateUpdateCopyGeneric.reference,
  fileStream: formCreateUpdateCopyGeneric.fileStream,
  files: formCreateUpdateCopyGeneric.files,

  watingServerResponse: formCreateUpdateCopyGeneric.watingServerResponse,
  getServerPresponseError: formCreateUpdateCopyGeneric.getServerPresponseError,

  loadingPostForm: formCreateUpdateCopyGeneric.loadingPostForm,
  postDataError: formCreateUpdateCopyGeneric.postDataError,

  toggleLayer: layerReducer.toggleLayer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    uploadFile,
    deleteFile,
    toggleFormCreateArchiveLayer,
    changeValues,
  }, dispatch);

export const CreateArchive = connect(mapStateToProps, mapDispatchToProps)(FormCreateArchive);
